<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-jobs">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-normal mx-auto">{{'Recrutement' | translate}}</h1>
  </div>
</div>

<div class="container mt-5">
    <div class="row">
        <div class="col-12 my-5 text-muted text-center" *ngIf="!allJobs.length">
            {{'Aucune annonce de recrutement n\'est disponible pour le moment' | translate}}
        </div>
        <div class="col-md-4 my-4" *ngFor="let job of allJobs"><div class="job" *ngIf="job['name_'+translate.store.currentLang] && job['description_'+translate.store.currentLang]">
                <div class="job-body">
                   <a class="titre-job" [routerLink]="language.navigateAccordingToLang(['/jobs/'+formateJobLink(job.id,job['name_'+translate.store.currentLang])])" title="job">{{job['name_'+translate.store.currentLang]}}</a>
                   <p class="date">{{language.getDate(job.date)}}</p>
                   <p class="description mb-4" [innerHTML]="removeHtmlTags(job['description_'+translate.store.currentLang]) | actus"></p>
                   <a [routerLink]="language.navigateAccordingToLang(['/jobs/'+formateJobLink(job.id,job['name_'+translate.store.currentLang])])" class="viewmore mb-3" title="see more">{{'Voir plus' | translate}}</a>
                </div>
            </div></div>
    </div>
</div>
